import React, { useContext, useEffect, useState } from "react";

import { Button, Card, Col, Image, Row, Spinner } from "react-bootstrap";
import { FaMemory } from "react-icons/fa";
import { IoColorPalette } from "react-icons/io5";
import { MdMonitorHeart } from "react-icons/md";
import AppContext from "../../context/AppContext";
import { scrollToTop } from "../../helper/HelperFunctions";
import MasterLayout from "../../layout/MasterLayout";
import axios from "axios";
import { withSwal } from "react-sweetalert2";

const ProductDetail = ({swal}) => {
  const { baseUrl, selectedProduct, isDesktopOrLaptop } = useContext(
    AppContext
  );
  const [addToCartLoading,setAddToCartLoading] = useState(false);

  const addToCart = () => {
    setAddToCartLoading(true);
    const formData = new FormData();
    let userId = localStorage.getItem("device_id");

    formData.append("user_id", userId);
    formData.append("product_id", selectedProduct.id);
    formData.append("qty", 1);
    formData.append("price", selectedProduct.price);

    axios
      .post(`${baseUrl}/api/guest/addToCart`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        if(resp.data.added == "yes")
        {
          swal.fire({
            title: "Congratulations!",
            text: `${selectedProduct.name} has been added to cart.`,
            icon: "success"
          });
        }else
        {
          swal.fire({
            title: "Oops!",
            text: `Cannot add product at this moment. Please try again later.`,
            icon: "error"
          });
        }
        setAddToCartLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setAddToCartLoading(false);
      });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <MasterLayout>
      <Card className="container rounded-4 p-5">
        <Row>
          <Col lg={6} md={6} xs={12}>
            <Image
              className="img img-fluid rounded-4"
              src={`${baseUrl}/storage/${selectedProduct.image}`}
            />
          </Col>
          <Col lg={6} md={6} xs={12}>
            <h5 className="text-secondary mt-5">By FixtechExperts</h5>
            <h1 className="txt-green mt-3 poppins-bold">
              {selectedProduct.name}
            </h1>
            <hr className="mt-5" style={{ borderWidth: 0.1 }}></hr>
            <h4 className="txt-green mt-2">£{selectedProduct.price}</h4>
            <p className="txt-green">
              Tax included. Shipping calculated at checkout.
            </p>
            <hr className="mt-2" style={{ borderWidth: 0.1 }}></hr>
            <Row>
              {selectedProduct.product_type == "Phone" ? (
                <Col lg={3} xs={6}>
                  <Card
                    className="gradient-bg1 shadow-lg mt-5 border-0"
                    style={{ height: 100 }}
                  >
                    <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                      <FaMemory size={"3rem"} className="text-white" />
                      <Card.Title
                        className="poppins-semiBold"
                        style={{
                          color: "#FFFFFF",
                          fontSize: "1rem",
                        }}
                      >
                        {selectedProduct.memory}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ) : null}

              <Col lg={3} xs={6}>
                <Card
                  className="gradient-bg2 shadow-lg mt-5 border-0"
                  style={{ height: 100 }}
                >
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                    <MdMonitorHeart size={"3rem"} className="text-white" />
                    <Card.Title
                      className="poppins-semiBold"
                      style={{
                        color: "#FFFFFF",
                        fontSize: "1rem",
                      }}
                    >
                      {selectedProduct.condition}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={3} xs={6}>
                <Card
                  className="gradient-bg3 shadow-lg mt-5 border-0"
                  style={{ height: 100 }}
                >
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                    <IoColorPalette size={"3rem"} className="text-white" />
                    <Card.Title
                      className="poppins-semiBold"
                      style={{
                        color: "#FFFFFF",
                        fontSize: "1rem",
                      }}
                    >
                      {selectedProduct.color}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              {selectedProduct.product_type == "Phone" ? (
                <Col lg={3} xs={6}>
                  <Card
                    className="gradient-bg0 shadow-lg mt-5 border-0"
                    style={{ height: 100 }}
                  >
                    <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                      <Card.Title
                        className="poppins-semiBold"
                        style={{
                          color: "#FFFFFF",
                          fontSize: "1rem",
                        }}
                      >
                        {selectedProduct.brand.name}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ) : (
                <Col lg={3} xs={6}>
                  <Card
                    className="gradient-bg0 shadow-lg mt-5 border-0"
                    style={{ height: 100 }}
                  >
                    <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                      <Card.Title
                        className="poppins-semiBold"
                        style={{
                          color: "#FFFFFF",
                          fontSize: "1rem",
                        }}
                      >
                        {selectedProduct.category.name}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              )}
            </Row>

            <Card
              onClick={() => {
                addToCart();
              }}
              className="gradient-bg2 shadow-lg mt-5 border-0"
              style={{ height: 50, cursor: "pointer" }}
            >
              <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                {addToCartLoading ? 
                <Spinner size="sm" style={{color:"white"}}/>
                : 
                <Card.Title
                  className="poppins-semiBold"
                  style={{
                    color: "#FFFFFF",
                    fontSize: "1rem",
                  }}
                >
                  Add To Cart
                </Card.Title>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>
    </MasterLayout>
  );
};

export default withSwal(ProductDetail);
